<template>
  <div class="kpt-detail-content template-content">
    <div class="kpt-detail-content-actions">
      <div class="buttons">
        <b-button
          type="is-primary is-outlined"
          icon-left="th-list"
          size="is-small"
          @click="getTemplate"
          :disabled="!network.nmsType || !network.antennaType || !network.modemType || !network.beamDisplayName"
          :loading="isLoadingTemplate">Calculate</b-button>
        <b-button
          type="is-primary is-outlined"
          icon-left="th-list"
          size="is-small"
          @click="clearAllFields">Clear</b-button>
        <!-- Keeping this for future use.
          <b-button
          type="is-primary is-outlined"
          icon-left="th-list"
          size="is-small"
          @click="saveTemplate"
          :disabled="!network.nmsType || !network.antennaType || !network.modemType || !network.beamDisplayName || isLoadingTemplate || !network.template || network.template.includes('The specified template does not exist')"
          :loading="isSavingTemplate">Save</b-button> -->
      </div>
      <hr style="margin-top: 0px" />
      <div class="columns">
        <div class="column">
          <b-field label="NMS" required>
            <b-select required expanded v-model="network.nmsType">
              <option :value="n.type" v-for="n in nmsTypes" :key="n.id">
                {{ n.name }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Antenna" required>
            <b-select expanded v-model="network.antennaType" required>
              <option value="U8">U8</option>
              <option value="U7">U7</option>
            </b-select>
          </b-field>
          <b-field label="Device Model" required>
            <b-select expanded v-model="network.modemType" required>
              <option
                :value="modemType.shortcode"
                v-for="modemType in modemTypes"
                :key="modemType.id">
                {{ modemType.name }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Beams" required>
            <b-select expanded v-model="network.beamDisplayName" required>
              <option
                :value="beam.displayName"
                v-for="beam in beams"
                :key="beam.id">
                {{ beam.displayName }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Template">
            <b-input
              type="textarea"
              rows="20"
              v-model="network.template" 
              readonly/>
          </b-field>
        </div>
        <div class="column"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { orderBy, uniqBy } from 'lodash';

export default {
  data() {
    return {
      network: {
        nmsType: '',
        antennaType: '',
        modemType: '',
        beamDisplayName: '',
        template: '',
      },
      isLoadingTemplate: false
      /* Keeping this code for future use 
      isSavingTemplate = false */
    };
  },
  methods: {
    async getTemplate() {
      this.isLoadingTemplate = true;
      const loadTemplate = await this.$store.dispatch('getTemplate', this.network);
      if (!loadTemplate.isSuccess) {
        if (loadTemplate.error != 'The specified template does not exist.') {
          this.$buefy.toast.open({
            duration: 3000,
            message: loadTemplate.error || 'Error encountered while attempting to load Template.',
            type: 'is-danger'
          });
        }
        this.network.template = loadTemplate.error;
      } else this.network.template = loadTemplate.data;
      this.isLoadingTemplate = false;
    },
    clearAllFields() {
      this.network.nmsType = '';
      this.network.antennaType = '';
      this.network.modemType = '';
      this.network.beamDisplayName = '';
      this.network.template = '';
    }
    /* Keeping this code for future use
    async saveTemplate() {
      this.isSavingTemplate = true;
      const saveTemplate = await this.$store.dispatch('saveTemplate', this.network);
      this.isSavingTemplate = false;
      if (!saveTemplate.isSuccess) {
        this.$buefy.toast.open({
          duration: 3000,
          message: saveTemplate.error || 'Error encountered while attempting to cancel the pending transfer.',
          type: 'is-danger'
        });
        return;
      }
      this.$buefy.toast.open({
        duration: 3000,
        message: 'Template Saved!',
        type: 'is-success'
      });
    } */
  },
  computed: {
    nmsTypes() {
      const nmsTypes = this.$store.state.admin?.network?.nmsTypes;
      if (!nmsTypes) return [];
      return orderBy(nmsTypes?.filter(n => n.active), ['name'], ['asc']);
    },
    beams() {
      const beams = this.$store.state.admin?.network?.beams;
      if (!beams) return [];
      // if NMS selected, filter beams
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!this.network.nmsType) {
        const nmsSelected = this.nmsTypes?.filter(n => n.type == this.network.nmsType)[0];
        // return unique to prevent duplicates
        return uniqBy(orderBy(beams?.filter(b => b.nmsId == nmsSelected.id), ['displayName'], ['asc']), 'displayName');
      }

      // all beams
      // return unique to prevent duplicates
      return uniqBy(orderBy(beams, ['displayName'], ['asc']), 'displayName');
    },
    modemTypes() {
      const deviceType = this.$store.state.devices?.types?.filter(d => d.shortcode == 'DEV_MODEM')[0];
      const deviceModels = this.$store.state.devices?.models; 
      if (!deviceType || !deviceModels) return [];
      return deviceModels.filter(m => m.deviceTypeId == deviceType.id);
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'network.nmsType': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.network.template = '';
      }
    },
    // eslint-disable-next-line func-names
    'network.antennaType': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.network.template = '';
      }
    },
    // eslint-disable-next-line func-names
    'network.modemType': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.network.template = '';
      }
    },
    // eslint-disable-next-line func-names
    'network.beamDisplayName': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.network.template = '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../styles/mixins";
.template-content {
   padding: 12px; 
   overflow-y: hidden
}
</style>
